import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV === 'production';

export default new Vuex.Store({
    strict: debug,
    state: {
        loadingFlags: [],
    },
    mutations: {
        setLoadingFlags(state, flagObj) {
            Vue.set(state.loadingFlags, flagObj.name, state.loadingFlags[flagObj.name] || []);

            if (flagObj.bool) {
                state.loadingFlags[flagObj.name].push(true);
            } else {
                state.loadingFlags[flagObj.name].pop();
            }
        },
    },
    getters: {
        getLoading({ loadingFlags }) {
            return stackName => !!(loadingFlags[stackName] || []).length;
        },
    },
});
